import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchLunchMealsShortList = async () => {
  const response = await axios.get(
    `${WiMuleSQL}/api/LunchMenu/GetLunchMealsShortList`
  );

  return response.data.data;
};

export const useGetLunchMealsShortList = (enabled = true) =>
  useQuery({
    queryKey: ["LunchMealsShortList"],
    queryFn: () => fetchLunchMealsShortList(),
    enabled,
  });
